import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import isEqual from "lodash.isequal";
import { Tab } from "@parkschannel/ui";
export const CounterTab = /*#__PURE__*/ memo((param)=>{
    let { children , tabId  } = param;
    return /*#__PURE__*/ _jsx(Tab.Tab, {
        tabId: tabId,
        children: children
    });
}, isPropsEqual);
function isPropsEqual(prevProps, nextProps) {
    return isEqual(prevProps, nextProps);
}
